const css = `@font-face {
    font-family: HyperLegible;
    src: url(/fonts/Atkinson-Hyperlegible-Bold-102.ttf);
    font-weight: bold;
  }

  @font-face {
    font-family: HyperLegible;
    src: url(/fonts/Atkinson-Hyperlegible-BoldItalic-102.ttf);
    font-weight: bold;
    font-style: italic;
  }

  @font-face {
    font-family: HyperLegible;
    src: url(/fonts/Atkinson-Hyperlegible-Italic-102.ttf);
    font-style: italic;
  }

  @font-face {
    font-family: HyperLegible;
    src: url(/fonts/Atkinson-Hyperlegible-Regular-102.ttf);
    font-weight: regular;
  }

  @font-face {
    font-family: Calamity;
    src: url("/fonts/Calamity Regular.woff2");
    font-weight: regular;
  }`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
